import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, catchError, tap, throwError } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ActivityDTO } from '../components/activity/activity.model'; // Add department model
import { baseURL, getHeaders, VERSION } from '../constant/constant';
import { ResponseCommonForList } from '../dtos/ResponseDTOs';
import { Activity } from '../dtos/Activity';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {
  private pageSize = 10;

  private currentPageSubject = new BehaviorSubject<number>(0);
  private pageSizeSubject =   new BehaviorSubject<number>(this.pageSize);

  currentPage$ = this.currentPageSubject.asObservable();
  pageSize$ = this.pageSizeSubject.asObservable();


  constructor(private http: HttpClient) { }

  create(activityDTO: ActivityDTO): Observable<ActivityDTO> {
    return this.http.post<ActivityDTO>(`${baseURL}activities/${VERSION}`, activityDTO, getHeaders());
  }

  AllActivities(): Observable<ActivityDTO[]> {
    const options = {
      headers: getHeaders().headers
    };
    return this.http.get<ActivityDTO[]>(`${baseURL}activities/${VERSION}/all`, options)
      .pipe(
        tap(),
        catchError(error => {
          console.error('Error fetching All Activity:', error);
          return throwError(error);
        })
      );
  }

  getAllActivity(filters: any, page: number = 0, size: number = 10): Observable<any> {
    let params = new HttpParams()
    .set('pageNo', page.toString())
    .set('pageSize', size.toString());

    if(filters) {
      if(filters.departmentIds) {
        params = params.set('departmentIds', filters.departmentIds);
      }
      if(filters.categoryTypeIds) {
        params = params.set('categoryTypeIds', filters.categoryTypeIds);
      }
      if(filters.ids) {
        params = params.set('ids', filters.ids);
      }
    }
    return this.http.get<any>(`${baseURL}activities/${VERSION}/list`, {
      params,
      headers: getHeaders().headers
    }).pipe(
      tap(),
      catchError(error => {
        console.error("Error Fetching All Activities.");
        return throwError(() => new Error('error'))
      })
    );
  }


  getActivityCategoryType(): Observable<any[]> {
    const options = {
      headers: getHeaders().headers
    };
    return this.http.get<any[]>(`${baseURL}categories/${VERSION}/category/type`, options)
      .pipe(
        tap(),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  getCategoryById(id: number): Observable<ActivityDTO> {
    return this.http.get<ActivityDTO>(`${baseURL}activities/${VERSION}?id=${id}`, getHeaders());
  }

  getActivityByCategoryTypeId(type: number): Observable<ResponseCommonForList<Activity>> {
    return this.http.get<ResponseCommonForList<Activity>>(`${baseURL}activities/${VERSION}/type?categoryTypeId=${type}`, getHeaders());
  }

  getActivityByCategoryTypeIds(ids: number[]): Observable<ResponseCommonForList<Activity>> {
    return this.http.get<ResponseCommonForList<Activity>>(`${baseURL}activities/${VERSION}/types?categoryTypeIds=${ids}`, getHeaders());
  }

  update(ActivityDTO: ActivityDTO): Observable<ActivityDTO> {
    return this.http.put<ActivityDTO>(`${baseURL}activities/${VERSION}`, ActivityDTO, getHeaders()).pipe(
      tap(),
      catchError(error => {
        return throwError(error);
      })
    );
  }

  deleteById(id: number): Observable<ActivityDTO> {
    return this.http.delete<ActivityDTO>(`${baseURL}activities/${VERSION}?id=${id}`, getHeaders());
  }

}